
import React from 'react'

import title from '../../lib/title'
import {
  TextInput,
  ToggleInput,
  Validators,
  MaskedTextInput,
  SelectInput
} from '../shared/FormBuilder'

export function renderPersonalInformation (persisted) {
  return (
    <div className='row'>
      <div className='col-xs-12 col-sm-4 col-md-4'>
        <TextInput
          label='First Name'
          name='first_name'
          required
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-4'>
        <TextInput
          label='Last Name'
          name='last_name'
          required
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-4'>
        <TextInput
          label='Suffix'
          name='suffix'
        />
      </div>
      <div className='col-xs-12 col-sm-12 col-md-12'>
        <TextInput
          label='Email'
          name='email'
          validators={[ Validators.email(), Validators.required() ]}
          disabled={persisted}
          required
        />
      </div>
      <div className='col-xs-12 col-sm-6 col-md-6'>
        <MaskedTextInput
          mask='111.111.1111'
          name='contact'
          label='Contact Phone'
          validators={[ Validators.phone() ]}
          helperText='mPower will display this number for this user. If a phone number is not provided, no number is presented.'
        />
      </div>
      <div className='col-xs-12 col-sm-6 col-md-6'>
        <MaskedTextInput
          mask='111.111.1111'
          name='phone'
          label='Alert Phone'
          required
          validators={[ Validators.phone(), Validators.required() ]}
          helperText='Compassion will send SMS alerts to this phone number while the user is on-duty.'
        />
      </div>
    </div>
  )
}

export function renderPreference () {
  return (
    <div className='row'>
      <div
        className='col-xs-4'
        key='trend'
        title={title.trend}
      >
        <ToggleInput
          label='Trend'
          name='trend'
        />
      </div>

      <div
        className='col-xs-4'
      >
        <SelectInput
          label='Patient Folder'
          name='on_patient_folder_open'
          options={[
            { value: 'null', label: 'Do nothing' },
            { value: 'open-chats', label: 'Open Chats' }
          ]}
        />
      </div>

      <div
        className='col-xs-4'
      >
        <SelectInput
          label='Encounter'
          name='on_encounter_open'
          options={[
            { value: 'null', label: 'Do nothing' },
            { value: 'open-encounter-summary', label: 'Open Encounter Summary' },
            { value: 'open-chats', label: 'Open Chats' }
          ]}
        />
      </div>
    </div>
  )
}

export function renderNotifications (role) {
  const isAgent = [ 'broker_access', 'csr_agent' ].includes(role)
  return (
    <div className='row'>
      <div
        className='col-xs-4'
        key='onduty'
        title={title.onDuty}
      >
        <ToggleInput
          label='On Duty'
          name='onduty'
        />
      </div>
      {!isAgent && (
        <>
          <div
            className='col-xs-4'
            key='monitoring'
            title={title.monitoring}
          >
            <ToggleInput
              label='Monitoring'
              name='monitoring'
            />
          </div>
          <div
            className='col-xs-4'
            key='oncall'
            title={title.onCall}
          >
            <ToggleInput
              label='On Call'
              name='oncall'
            />
          </div>
        </>
      )}
      <div
        className='col-xs-4'
        key='concierge'
        title={title.concierge}
      >
        <ToggleInput
          label='Concierge'
          name='concierge'
        />
      </div>
      <div
        className='col-xs-4'
        key='practitioner_notifications'
        title={title.practitionerNotifications}
      >
        <ToggleInput
          label='Practitioner Messages'
          name='practitioner_notifications'
        />
      </div>
    </div>
  )
}
